import classnames from 'classnames';

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  children: React.ReactNode;
  bgColor?: string;
  disabled?: boolean;
}

export default function EventButton({
  children,
  bgColor = 'blue',
  disabled = false,
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={disabled}
      {...props}
      className={classnames(
        'px-8 py-3 font-radikal rounded-[4px] w-full uppercase bg-swopa-secondary-light-blue hover:bg-[#2B81EC] text-white text-xs hover:ease-in-out duration-300',
        props.className,
        { 'opacity-50': disabled },
        { 'pointer-events-none': disabled },
      )}
    >
      {children}
    </button>
  );
}
